import { SearchFilterDTO } from "../../types";
import { NumberSearchFilterDTO, NumberSearchFilterId } from "../../types/search/SearchFilters/NumberSearchFilter";

const numberSearchTypes: Record<NumberSearchFilterId, true> = {
  "amenities-distance-filter": true,
  "power-distance-filter": true,
  "traffic-count-number-filter": true,
  "adopted-roads-distance-id": true,
};

export const isNumberSearchDTO = (filter: SearchFilterDTO): filter is NumberSearchFilterDTO =>
  filter.id in numberSearchTypes;
